import React from 'react';

const ProfileIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      {...props}
    >
      <g fill="currentcolor">
        <path d="M37.684 41.934l-25.399-.985.164-1.133c.918-6.148 6.301-10.8 12.516-10.8 6.617 0 12.168 5.168 12.637 11.77zm-22.95-2.95l20.684.801c-.902-4.969-5.285-8.703-10.434-8.703-4.836-.016-9.05 3.316-10.25 7.902zm0 0"></path>
        <path d="M24.984 30.852c-4.101 0-7.433-3.336-7.433-7.434a7.439 7.439 0 017.433-7.434c4.098 0 7.434 3.332 7.434 7.434-.02 4.098-3.336 7.434-7.434 7.434zm0-12.786a5.361 5.361 0 00-5.367 5.368 5.364 5.364 0 005.367 5.367 5.366 5.366 0 005.368-5.367 5.364 5.364 0 00-5.368-5.368zm0 0"></path>
        <path d="M39.102 41.984L9.75 40.852l-3.484-5.903-1.133-21.484 2.05-5.45 12.75 2.368L34 8.867l10.883 2.465L43.266 39zm-28.153-3.152l27.516 1.066 2.8-2 1.45-24.949-8.832-2-14.016 1.516L8.5 10.352l-1.285 3.433L8.3 34.332zm0 0"></path>
        <path d="M24.984 26.668c-1.382 0-2.617-.52-3.316-1.383l1.598-1.3c.25.3.867.617 1.699.617.836 0 1.469-.301 1.703-.618l1.598 1.301c-.664.863-1.899 1.383-3.282 1.383zm0 0"></path>
      </g>
    </svg>
  );
};

export default ProfileIcon;
